import { createAction, props } from '@ngrx/store';
import { Payment } from './payment.model';

// fetch one 
export const fetchSingleRecord = createAction(
    '[Data] fetch single record payment',
    props<{step: string, signature: string}>()
);
export const fetchSingleRecordSuccess = createAction(
    '[Data] fetch single record payment success', 
    props<{ singleData: Payment }>()
);
export const fetchSingleRecordFail = createAction(
    '[Data] fetch single record payment failure', 
    props<{ error: string }>()
);

// Add Data
export const addRecord = createAction(
    '[Data] Add payment',
    props<{ newData: any, linkUrl: string }>()
);
export const addRecordSuccess = createAction(
    '[Data] Add payment success'
);
export const addRecordFailure = createAction(
    '[Data] Add payment failure',
    props<{ error: string }>()
);

//Reset State
export const resetState = createAction(
    '[Data] reset state payment',
);